export default "__VITE_ASSET__Boc0DMe3__"